/**
 * Punto de extensión del formulario público de validación externa
 * (ExternalValidationForm). El PROYECTO llena este archivo con lo que necesite
 * (avisos, subida de documentación adicional, etc.); el generador lo emite
 * SIEMPRE con este mismo contenido estable, así el merge base→develop
 * preserva la versión llenada — mismo contrato que los stubs de
 * `components/custom/`.
 *
 * Se renderiza DOS VECES, y `slot` dice dónde: "top" arriba de los campos,
 * antes del primer grupo, que es donde va lo que la persona debería ver antes
 * de ponerse a completar; "bottom" entre los mensajes de error y el botón de
 * enviar, para lo que corresponde al momento de confirmar. Son instancias
 * distintas y React no comparte estado entre ellas: si el proyecto necesita
 * que lo que se hace arriba se vea abajo, eso lo resuelve el proyecto.
 *
 * Contrato de props (genérico, sin conocimiento del dominio del proyecto):
 *  - entityData: el registro tal como lo devolvió /verify-email/info
 *  - formData:   los campos editables con lo que el usuario ya corrigió
 *  - vid / sig:  las credenciales del link público (para llamar endpoints
 *                públicos propios del proyecto)
 *  - lookups:    las opciones de los campos de referencia (por entidad), que
 *                es lo que hace falta para completar uno: el formulario guarda
 *                el id de la fila, no su nombre.
 *  - patchForm: completa campos del formulario. Solo entran los editables: lo
 *                que el formulario muestra como fijo lo sigue decidiendo él.
 *  - registerBeforeSubmit: registra una comprobación que el formulario corre
 *                DESPUÉS de validar los campos y ANTES de enviar. Devolver
 *                false cancela el envío (el agregado ya mostró lo que tenga
 *                que mostrar); devolver una promesa permite esperar una
 *                decisión del usuario antes de seguir. Registrar `null` lo
 *                desactiva.
 *
 * NO EDITAR este stub en el generador: cualquier cambio acá conflictúa con
 * todos los proyectos que lo hayan llenado.
 */

import React from 'react';

export interface ExternalValidationExtrasProps {
  /** Dónde se está renderizando: arriba de los campos o antes de enviar. */
  slot: 'top' | 'bottom';
  entityData: Record<string, any>;
  formData: Record<string, any>;
  vid: string;
  sig: string;
  /** Las opciones de los campos de referencia, las mismas que usa el formulario. */
  lookups?: Record<string, { id: string; displayId: string; parentId?: string }[]>;
  patchForm: (valores: Record<string, any>) => void;
  registerBeforeSubmit: (check: (() => boolean | Promise<boolean>) | null) => void;
}

const ExternalValidationExtras: React.FC<ExternalValidationExtrasProps> = () => null;

export default ExternalValidationExtras;
